import { defineMessages } from '@jutro/locale';

export default defineMessages({
    continue: {
        id: 'ml.gateway.MLDeclineQuoteConfirmationPopup.continue',
        defaultMessage: 'Continue'
    },
    cancel: {
        id: 'ml.gateway.MLBundleQuestionPopup.cancel',
        defaultMessage: 'Cancel'
    },
    declineLetters : {
        id: 'ml.gateway.MLBundleQuestionPopup.Decline Letters',
        defaultMessage: 'Decline Quote'
    },
    email:{
       id: 'ml.gateway.MLBundleQuestionPopup.Email',
       defaultMessage:'Email'
    },
    readtoCustomer:{
       id: 'ml.gateway.MLBundleQuestionPopup.Read to Customer',
       defaultMessage:'Quote will be declined. Please confirm if you want to proceed'
    },
    downloadForm:{
       id: 'ml.gateway.MLBundleQuestionPopup.Download Form',
       defaultMessage:'Are you sure you want to download?'
    },
    yourEmailAddressHere: {
        id: 'ml.gateway.MLBundleQuestionPopup.yourEmailAddressHere',
        defaultMessage: 'Your email address here'
    },
});
